import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Grid,
  Typography,
  Autocomplete,
  InputAdornment,
} from "@mui/material";
import { Stack } from "@mui/system";
import DoneIcon from "@mui/icons-material/Done";
import { setIsLoading } from "../../../../../features/userSlice";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";
import {
  setGeoAssociatedTerritoryFilter,
  setGeoTimezoneFilter,
  setSelectedEntityType,
} from "../../../../../features/metaEntitiesSlice";
import { useSearchParams } from "react-router-dom";

interface GeoProps {
  open: boolean;
  handleClose: () => void;
  geoName: any;
  territoryUID: any;
  timeZone: any;
  selectedShareuid: any;
  oauthTokenHeader: any;
  setGeoName: any;
  setTimeZone: any;
  setTerritoryUID: any;
  setSelectedShareuid: any;
  selectedRowData: any;
  setSelectedRowData: any;
  setMetaGeos: any;
}

function EditGeoModal({
  open,
  handleClose,
  geoName,
  setGeoName,
  territoryUID,
  setTerritoryUID,
  timeZone,
  setTimeZone,
  selectedShareuid,
  oauthTokenHeader,
  selectedRowData,
}: GeoProps) {
  const [territoryDetails, setTerritoryDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (open) {
      MetaEntitiesEndPointLogic.getTerritory(
        setTerritoryDetails,
        oauthTokenHeader
      );
    }
  }, [open, oauthTokenHeader]);

  const UpdateGeoData = async () => {
    const data = {
      territory_name: geoName,
      territory_shared_uid: territoryUID,
      timezone: timeZone,
    };
    try {
      setLoading(true);
      setIsLoading(true);
      if (oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.updateMetaGeo(
          oauthTokenHeader,
          data,
          selectedShareuid
        );
        dispatch(setSelectedEntityType(""));
        dispatch(setGeoAssociatedTerritoryFilter(null));
        dispatch(setGeoTimezoneFilter(null));
        const newSearchParams = new URLSearchParams(searchParams);
        newSearchParams.delete("filters"); // Remove filters
        setSearchParams(newSearchParams);
      } else {
        throw new Error("User doesn't have permissions to create Geo");
      }
      if (oauthTokenHeader) {
        setIsLoading(true);
        await MetaEntitiesEndPointLogic.getMetaGeoDuplicate(
          oauthTokenHeader,
          dispatch
        );
      }
    } catch (error) {
      console.error(error, "error");
    } finally {
      setLoading(false);
      setIsLoading(false);
      handleClose();
      await MetaEntitiesEndPointLogic.getMetaGeoDuplicate(
        oauthTokenHeader,
        dispatch
      );
    }
  };
  useEffect(() => {
    if (oauthTokenHeader) {
      setGeoName(selectedRowData?.geo_name);
      setTerritoryUID(selectedRowData?.territory_shared_uid);
      setTimeZone(selectedRowData?.timezone);
    }
  }, [
    oauthTokenHeader,
    selectedRowData,
    setGeoName,
    setTerritoryUID,
    setTimeZone,
  ]);

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <Dialog
            open={open}
            onClose={handleClose}
            PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
          >
            <Paper sx={{ padding: "16px 24px 20px 24px" }}>
              <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
                Edit Geo Details
              </DialogTitle>
              <Typography sx={{ mb: 1 }}>Details</Typography>
              <Grid container mt={0} columnSpacing={3}>
                <Grid item xs={6}>
                  <TextField
                    value={geoName}
                    onChange={(e: any) => setGeoName(e.target.value)}
                    id="outlined-multiline-flexible"
                    label="Geo Name *" // Set your label here
                    placeholder="Enter Geo Name" // Set your placeholder here
                    color="secondary"
                    size="small"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6}>
                  <Autocomplete
                    options={territoryDetails}
                    getOptionLabel={(option: any) => option?.territory_name}
                    value={territoryDetails.find(
                      (option: any) => option.shared_uid === territoryUID
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Source"
                        placeholder="Choose Associated Territory Name."
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start"></InputAdornment>
                          ),
                        }}
                        color="secondary"
                        required
                      />
                    )}
                    size="small"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6} sx={{ mt: 2 }}>
                  <TextField
                    value={timeZone}
                    onChange={(e: any) => setTimeZone(e.target.value)}
                    id="outlined-multiline-flexible"
                    label="Time Zone *" // Set your label here
                    placeholder="Enter Time Zone" // Set your placeholder here
                    color="secondary"
                    size="small"
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Typography
                sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
              >
                All fields are mandatory.
              </Typography>

              <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
                <Button color="secondary" onClick={handleClose} sx={{ mr: 1 }}>
                  CANCEL
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  disabled={!geoName || !territoryUID || !timeZone}
                  onClick={UpdateGeoData}
                  data-tracker="235"
                >
                  Save Changes <DoneIcon sx={{ ml: 1 }} />
                </Button>
              </Stack>
            </Paper>
          </Dialog>
        </>
      )}
    </>
  );
}

export default EditGeoModal;
